import { render, staticRenderFns } from "./ProductOptionInput.vue?vue&type=template&id=31705d80&scoped=true"
import script from "./ProductOptionInput.vue?vue&type=script&lang=ts"
export * from "./ProductOptionInput.vue?vue&type=script&lang=ts"
import style0 from "./ProductOptionInput.vue?vue&type=style&index=0&id=31705d80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31705d80",
  null
  
)

export default component.exports